<mat-card appearance="outlined" class="card-primary">
  <ngx-skeleton-loader
    animation="progress"
    [theme]="{ width: '150px', marginTop: '10px', height: '30px' }"
    count="1"
    appearance="line"></ngx-skeleton-loader>
  <ngx-skeleton-loader
    animation="progress"
    [theme]="{ width: '100%', marginTop: '0px', height: '40px' }"
    count="4"
    appearance="line"></ngx-skeleton-loader>
</mat-card>
